/**
 * Seat allocation rule: the first N attendees (by index) take the available
 * seats; everyone after spills onto the waitlist. Centralizing this here keeps
 * all callsites in lockstep with the backend's expectation.
 */
export function computeIsWaitlist(
  attendeeIndex: number,
  availableSeats: number,
): boolean {
  return attendeeIndex >= availableSeats;
}

export function computeWaitlistedCount(
  selectedAttendeeCount: number,
  availableSeats: number,
): number {
  return Math.max(0, selectedAttendeeCount - availableSeats);
}

export function computeConfirmedCount(
  selectedAttendeeCount: number,
  availableSeats: number,
): number {
  return Math.min(selectedAttendeeCount, availableSeats);
}
